import { Navigate } from 'react-router';
import { UniversalLoadingState } from '@afrilink/ui';
import { useAuth } from '@/shared/contexts/AuthContext';
import { useStaffRole } from '@/shared/hooks/useStaffRole';
import { defaultRouteForRole } from './defaultRouteForUser';

/**
 * Renders for `/` and the catch-all `*` route. Sends users to:
 *   - /sign-in   if not authenticated
 *   - /admin     if signed in as auth.users.raw_app_meta_data.role staff/admin/super_admin (existing SightHost internal staff)
 *   - /sales     if signed in as Phase 11 external sales staff (sales_agent/sales_manager) — no auth role, only staff_profile.role
 *   - /app       otherwise (customer)
 */
export function HomeRedirect() {
  const { loading: authLoading, isAuthenticated, user } = useAuth();
  const { loading: roleLoading, isSalesStaff } = useStaffRole();

  if (authLoading || roleLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-card-subtle">
        <UniversalLoadingState variant="spinner" caption="Loading…" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />;
  }

  // Single source of truth for "where does this user belong" — shared with
  // ProtectedRoute and SignInPage so the three guards cannot drift (they did:
  // incident 2026-08-03 put an external sales agent in the customer portal).
  return <Navigate to={defaultRouteForRole(user, isSalesStaff)} replace />;
}
